import React from 'react'
import MessageAlert from 'app/components/MessageAlert'
import { FormattedMessage } from 'react-intl'

export const crmSuccessSaved = (dispatchRedux) => {
  dispatchRedux(
    MessageAlert.showSuccess({
      message: <FormattedMessage id={'crm.successSaved'} />,
    }),
  )
}

export const noteSuccessSaved = (dispatchRedux) => {
  dispatchRedux(
    MessageAlert.showSuccess({
      message: <FormattedMessage id={'note.successSaved'} />,
    }),
  )
}

export const noteSuccessDeleted = (dispatchRedux) => {
  dispatchRedux(
    MessageAlert.showSuccess({
      message: <FormattedMessage id={'note.successDeleted'} />,
    }),
  )
}

export const noteSuccessUpdated = (dispatchRedux) => {
  dispatchRedux(
    MessageAlert.showSuccess({
      message: <FormattedMessage id={'note.successUpdated'} />,
    }),
  )
}

export const subscriberApproved = (dispatchRedux) => {
  dispatchRedux(
    MessageAlert.showSuccess({
      message: <FormattedMessage id="subscriber.approved.msgText" />,
    }),
  )
}

export const subscriberRejected = (dispatchRedux) => {
  dispatchRedux(
    MessageAlert.showSuccess({
      message: <FormattedMessage id="subscriber.rejected.msgText" />,
    }),
  )
}
